export const api = {
  group: {
    queryPersonnelgroup: "/bms/personAuthorization/queryPersonnelgroup.json", //查询群组列表
    addGroupAuth: "/bms/personAuthorization/addPersonnelgroupAuthorization.json", //群组加设备
    deleteGroupAuth: "/bms/personAuthorization/deletePersonnelgroupAuthorization.json", //群组加设备
  },
  device: {
    queryGroupDevice: "/bms/personAuthorization/queryPersonnelgroupDeviceAuthorization.json", //查询群组设备列表
  },
  person: {
    queryPersonList: "/bms/personAuthorization/queryPersonnelByGroup.json", //查询人员列表
    queryPersonDevice: "/bms/personAuthorization/queryPersonDeviceAuthorization.json", //查询人员关联设备
    addPersonDevice: "/bms/personAuthorization/addPersonnelAuthorization.json", //添加人员关联设备
    delPersonDevice: "/bms/personAuthorization/deletePersonDeviceAuthorization.json", //删除人员关联设备
  },
  type: {
    queryPersonType: "/bms/personAuthorization/queryPersonnelMark.json", //查询人员类型
    queryTypeDevice: "/bms/personAuthorization/queryPersonnelMarkDeviceAuthorization.json", //查询类型关联设备
    addTypeDevice: "/bms/personAuthorization/addPersonnelMarkAuthorization.json", //新增类型关联设备
    delTypeDevice: "/bms/personAuthorization/deletePersonnelMarkAuthorization.json", //删除类型关联设备
  }
};
